export default __webpack_public_path__ + "static/media/TEXTLAB-LOGIN-bw.aa5597ba.svg";